import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import api from '../../utils/api';
import { getLocalDateInputValue } from '../../utils/dateUtils';
import toast from 'react-hot-toast';

const TerminateModal = ({ isOpen, onClose, personnel, unreturnedCount = 0, onDone }) => {
    const [terminationDate, setTerminationDate] = useState(getLocalDateInputValue());
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen || !personnel) return null;

    const handleTerminate = async () => {
        setIsSubmitting(true);
        try {
            await api.patch(`/personnel/${personnel.id}/terminate`, { terminationDate });
            toast.success('Personel işten çıkarıldı olarak işaretlendi.');
            onDone?.();
            onClose();
        } catch (error) {
            toast.error(error.response?.data?.message || 'İşlem başarısız.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4">
            <div className="bg-dark-card border border-slate-700 w-full max-w-md text-white rounded-2xl shadow-2xl overflow-hidden">
                <div className="flex justify-between items-center p-5 border-b border-slate-700/50 bg-slate-800/30">
                    <h2 className="text-lg font-bold">İşten Çıkar</h2>
                    <button onClick={onClose} className="p-2 text-slate-400 hover:text-white hover:bg-slate-700/50 rounded-full transition-colors">
                        <X size={20} />
                    </button>
                </div>
                <div className="p-5 space-y-4">
                    <p className="text-sm text-slate-300">
                        <span className="font-semibold">{personnel.fullName}</span> personelini işten çıkarılmış olarak işaretleyeceksiniz.
                        Kayıt <span className="font-semibold text-primary-400">silinmez</span>, geçmişi korunur ve “Ayrılan” filtresinde görünür.
                    </p>

                    {unreturnedCount > 0 && (
                        <div className="flex items-start gap-2 bg-orange-500/10 border border-orange-500/30 text-orange-300 rounded-lg p-3 text-sm">
                            <AlertTriangle size={18} className="shrink-0 mt-0.5" />
                            <span>Bu personelde iade edilmemiş <span className="font-bold">{unreturnedCount}</span> adet zimmet var. Çıkışta bunları teslim aldığınızdan emin olun.</span>
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-1">Ayrılış Tarihi</label>
                        <input type="date" value={terminationDate} onChange={(e) => setTerminationDate(e.target.value)} className="w-full px-4 py-2 bg-slate-800 border border-slate-600 rounded-lg focus:outline-none focus:border-primary-500 text-white cursor-pointer" />
                    </div>
                </div>
                <div className="p-4 border-t border-slate-700/50 bg-slate-800/95 flex justify-end gap-3">
                    <button onClick={onClose} className="px-5 py-2.5 rounded-lg font-medium text-slate-300 hover:bg-slate-700 transition-colors">Vazgeç</button>
                    <button onClick={handleTerminate} disabled={isSubmitting} className="px-6 py-2.5 rounded-lg font-bold text-white bg-red-600 hover:bg-red-500 disabled:opacity-50 transition-all">
                        {isSubmitting ? 'İşleniyor...' : 'İşten Çıkar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TerminateModal;
